// extracted by mini-css-extract-plugin
export default {"countdownTimer":"CountdownContent_countdownTimer__aJM5a"};